/**
 * Default: Components / Shared > Button
 *
 * @copyright 2026 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

import {
	SelectorEngine,
	Data,
	Manipulator,
	EventHandler
} from '@ifabnpm/bootstrap/dom.js';

import Button from '@ifabnpm/bootstrap/component/button.js';

// -------
// Private
// -------

const parseCustomButton = async (element) => {
	const text = element.textContent;

	if (text) {
		// Nur Modifier-Classes übrig lassen.
		const classes = element.getAttribute('class');
		const elementClasses = classes.split(' ').filter((cls) => cls.startsWith('-'));

		// Attribut `class` aktualisieren.
		element.setAttribute('class',`button ${elementClasses}`);

		// Elementtextinhalt leeren.
		element.textContent = '';

		// Buttonlabel integrieren.
		Manipulator.elementAppend(`<span aria-hidden="true" class="button__background">
			<svg preserveAspectRatio="none" viewBox="0 0 200 95" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#svg-bg-button"></use></svg>
		</span>`, element);
		Manipulator.elementAppend(`<span class="button__label">${text}</span>`, element);
	}
};

// ------
// Public
// ------

/**
 * @returns {Promise<void>}
 */
const init = async (o = {}) => {
	Button.init();

	const customButtons = SelectorEngine.find('a.button-custom');

	for (const element of customButtons) {
		await parseCustomButton(element);
	}
};

// Export
export default {
	init: init
};
